// polyBuilder: builds a polynomial
// WARNING: first element in coefficientArray must be non-zero
// combine (0,x) to '', (1,x) to +x, (-1,x) to -x, (2,x) to +2x, (-2,x) to -2x
function algebraZipper(a, b) {
    if (a == '0') {
        return '';
    }
    else if (a[0] == '-') { // a already contains necessary number
        if (a == '-1' && b) {
            return '-' + b;
        }
        else {
            return a + b;
        }
    }
    else { // positive, add a +_sign
        if (a == '1' && b) {
            return '+' + b;
        }
        else {
            return '+' + a + b;
        }
    }
}
export default function polyBuilder(coefficientArray, x = 'x', firstPower = 0, ascending = true) {
    let polyString = '';
    // typeset first term
    let firstCoefficient = coefficientArray.shift();
    if (typeof firstCoefficient === 'number') {
        firstCoefficient = firstCoefficient.toString();
    }
    else if (typeof firstCoefficient === 'string') {
    }
    else {
        firstCoefficient = firstCoefficient.toString();
    }
    if (firstPower == 0) {
        polyString += firstCoefficient;
    }
    else if (firstPower == 1) {
        if (firstCoefficient == '1') {
            firstCoefficient = '';
        }
        else if (firstCoefficient == '-1') {
            firstCoefficient = '-';
        }
        polyString += firstCoefficient + x;
    }
    else {
        if (firstCoefficient == '1') {
            firstCoefficient = '';
        }
        else if (firstCoefficient == '-1') {
            firstCoefficient = '-';
        }
        polyString += firstCoefficient + x + '^{' + firstPower.toString() + '}';
    }
    ;
    let power = firstPower;
    // loop over all other coefficients
    coefficientArray.forEach(coefficient => {
        if (typeof coefficient === 'number') {
            coefficient = coefficient.toString();
        }
        else if (typeof coefficient === 'string') {
        }
        else {
            coefficient = coefficient.toString();
        }
        if (ascending) {
            power += 1;
        }
        else {
            power -= 1;
        }
        let b = x + "^{" + power.toString() + "}";
        if (power == 0) {
            b = '';
        }
        else if (power == 1) {
            b = x;
        }
        polyString += algebraZipper(coefficient, b);
    });
    return polyString;
}
